import type { PropPickProps } from '../../common/types/propPickProps.type';

export function getLineLabelText(line: PropPickProps['line']): string {
  const fromApi = line.display?.trim();
  if (fromApi) {
    return fromApi;
  }
  return line.label;
}
